import React, { useContext, createContext } from 'react';
import { noop } from 'lodash';

import {
  useCommunityInfo as useCommunityInternal,
  ReturnType as useCommunityReturnType,
} from 'pages/community/useCommunityInfo';

const initialContext: useCommunityReturnType = {
  applications: [],
  isLoading: false,
  isLoadingMore: false,
  hasMoreRecords: false,
  applicationsMetaInfo: {},
  size: 0,
  setSize: () => noop,
  isValidating: false,
  mutate: () => noop,
  selectedCommunityType: '',
  onChangeCommunityType: () => noop,
  pagesIndex: 0,
  setpagesIndex: () => noop,
  per_page_count: 0,
};

const CommunityContext = createContext<useCommunityReturnType>(initialContext);

export const useCommunityInfo = (): useCommunityReturnType =>
  useContext(CommunityContext);

export const CommunityProvider: React.FC = ({ children }) => {
  const value = useCommunityInternal();

  return (
    <CommunityContext.Provider value={value}>
      {children}
    </CommunityContext.Provider>
  );
};
